import React from "react";
import moment from "moment";
import Row from "../../../../common/grid/Row";
import Col from "../../../../common/grid/Col";
import Button from "../../../../common/button/Button";
import ProgressBar from './ProgressBar';
import RenderIfUserHas from '../../../../common/roles/RenderIfUserHas.js';

import "./ProjectCard.css";

const ProjectCard = ({ project, onDelete, onEdit, onSeeMore }) => {
	const startMs = moment(project.start_date).valueOf();
	const endMs = moment(project.end_date).valueOf();
	const current = moment().valueOf() - startMs;
	const range = endMs - startMs;

	const progress = (current / range) * 100;

	return (
		<Col project-card>
			{project.photo_url && (
				<div className="project-thumbnail">
					<img src={"https://eldocs.net" + project.photo_url} alt="" />
				</div>
			)}

			<Col _bottom-16 _no-grow project-card-content>
				<Col _bottom-32>
					<Col _bottom-8 content-top>
						<h2>{project.name}</h2>
						<Col _bottom-4>
							<div className="secondary">
								{moment(project.start_date).format("ll")}
								{" - "}
								{moment(project.end_date).format("ll")}
							</div>
							<div className="secondary">
								{project.users.length} assigned employee(s)
							</div>
						</Col>
					</Col>
					<div>
						<Button
							onClick={e => {
								onSeeMore(project.id, e);
							}}
							className="btn-ghost padding"
						>
							SEE MORE
						</Button>
					</div>
				</Col>
				{/* <div>{project.description}</div> */}

				<RenderIfUserHas roles={["admin"]}>
					<Row _no-grow _gap-16 _flex-end actions>
						<Button
							onClick={e => {
								onEdit(project.id, e);
							}}
							className="btn-plain"
						>
							EDIT
						</Button>
						<Button
							onClick={e => {
								onDelete(project.id, e);
							}}
							className="btn-plain btn-red-text"
						>
							DELETE
						</Button>
					</Row>
				</RenderIfUserHas>
			</Col>
			<ProgressBar progress={progress}/>
		</Col>
	);
};

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/main/projects/index/ProjectCard.js